import { isStudioModuleEntitled, readAuthUser } from "./studioModules";

export const isProductCaptureEnabled = (): boolean =>
  process.env.REACT_APP_PRODUCT_CAPTURE_ENABLED === "true" ||
  process.env.REACT_APP_ENV === "loc";

export const canUseProductCapture = (role?: string): boolean => {
  if (!isProductCaptureEnabled() || !role) {
    return false;
  }
  const allowed =
    role === "SUPER_ADMIN" ||
    role === "ORGANIZATION_ADMIN" ||
    role === "ORGANIZATION_MANAGER";
  if (!allowed) {
    return false;
  }
  if (role === "SUPER_ADMIN") {
    return true;
  }
  return isStudioModuleEntitled("CAPTURE");
};

export const canCurrentUserUseProductCapture = (): boolean => {
  try {
    const auth = readAuthUser();
    return canUseProductCapture(auth?.users?.role);
  } catch {
    return false;
  }
};
